import { api } from './api';

export const clientsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Get all clients
    getClients: builder.query({
      query: () => '/clients',
      providesTags: ['ClientList'],
      // Cache for 5 minutes and refetch on focus
      keepUnusedDataFor: 300,
    }),

    // Get single client by ID
    getClient: builder.query({
      query: (id) => `/clients/${id}`,
      providesTags: (result, error, id) => [{ type: 'Client', id }],
      keepUnusedDataFor: 300,
    }),

    // Create new client with optimistic update
    createClient: builder.mutation({
      query: (clientData) => ({
        url: '/clients',
        method: 'POST',
        body: clientData,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        // Optimistic update: add to clients list
        const patchResult = dispatch(
          clientsApi.util.updateQueryData('getClients', undefined, (draft) => {
            draft.push({
              ...arg,
              id: `temp-${Date.now()}`, // Temporary ID
            });
          })
        );

        try {
          const { data } = await queryFulfilled;
          // Update the cache with the real response
          dispatch(
            clientsApi.util.updateQueryData('getClients', undefined, (draft) => {
              const index = draft.findIndex(c => c.id === `temp-${Date.now()}`);
              if (index !== -1) {
                draft[index] = data;
              }
            })
          );
        } catch {
          // Rollback on error
          patchResult.undo();
        }
      },
      invalidatesTags: ['ClientList'],
    }),

    // Delete client with optimistic update
    deleteClient: builder.mutation({
      query: (id) => ({
        url: `/clients/${id}`,
        method: 'DELETE',
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        // Optimistic update: remove from list
        const patchResult = dispatch(
          clientsApi.util.updateQueryData('getClients', undefined, (draft) => {
            return draft.filter(c => c.id !== id);
          })
        );

        try {
          await queryFulfilled;
        } catch {
          // Rollback on error
          patchResult.undo();
        }
      },
      invalidatesTags: (result, error, id) => [
        'ClientList',
        { type: 'Client', id },
      ],
    }),
  }),
});

export const {
  useGetClientsQuery,
  useGetClientQuery,
  useCreateClientMutation,
  useDeleteClientMutation,
} = clientsApi;
